import { LISTING_PACKAGE, ListingPackage } from 'models/Listing';
import { transformPriceNumberToCurrencyString } from 'utils';
import { LISTING_PACKAGE_PRICES } from 'data/prices';

type ListingPackageDetails = {
  color: string;
  title: string;
  time?: string;
  description?: string;
  price?: string;
  listOfPerks?: string[];
};

export const LISTING_PACKAGE_DATA: Record<
  ListingPackage,
  ListingPackageDetails
> = {
  [LISTING_PACKAGE.BRONZE]: {
    color: 'black',
    title: 'bronze_title',
    description: 'bronze_description',
    price: transformPriceNumberToCurrencyString(
      LISTING_PACKAGE_PRICES[LISTING_PACKAGE.BRONZE],
    ),
    listOfPerks: ['bronze_perk_1', 'bronze_perk_2', 'bronze_perk_3'],
  },
  [LISTING_PACKAGE.SILVER]: {
    color: 'black',
    title: 'silver_title',
    time: 'silver_time',
    description: 'silver_description',
    price: transformPriceNumberToCurrencyString(
      LISTING_PACKAGE_PRICES[LISTING_PACKAGE.SILVER],
    ),
    listOfPerks: [
      'silver_perk_1',
      'silver_perk_2',
      'silver_perk_3',
      'silver_perk_4',
      'silver_perk_5',
    ],
  },
  [LISTING_PACKAGE.GOLD]: {
    color: 'blue',
    title: 'gold_title',
    time: 'gold_time',
    description: 'gold_description',
    price: transformPriceNumberToCurrencyString(
      LISTING_PACKAGE_PRICES[LISTING_PACKAGE.GOLD],
    ),
    listOfPerks: [
      'gold_perk_1',
      'gold_perk_2',
      'gold_perk_3',
      'gold_perk_4',
      'gold_perk_5',
      'gold_perk_6',
    ],
  },
  [LISTING_PACKAGE.BASIC]: {
    color: 'black',
    title: 'basic_title',
    description: 'basic_description',
    price: transformPriceNumberToCurrencyString(
      LISTING_PACKAGE_PRICES[LISTING_PACKAGE.BASIC],
    ),
    listOfPerks: ['basic_perk_1', 'basic_perk_2', 'basic_perk_3'],
  },
  [LISTING_PACKAGE.COMPREHENSIVE]: {
    color: 'black',
    title: 'comprehensive_title',
    description: 'comprehensive_description',
    price: transformPriceNumberToCurrencyString(
      LISTING_PACKAGE_PRICES[LISTING_PACKAGE.COMPREHENSIVE],
    ),
    listOfPerks: [
      'comprehensive_perk_1',
      'comprehensive_perk_2',
      'comprehensive_perk_3',
      'comprehensive_perk_4',
      'comprehensive_perk_5',
    ],
  },
  [LISTING_PACKAGE.NO_PACKAGE]: { color: 'black', title: 'no_package_title' },
};
